module.exports = __webpack_public_path__ + "img/fsg_football.b4f35212.svg";